import React from "react";
import Payments from "modules/payments";

const PaymentsPage = () => {
  return <Payments />;
};

export default PaymentsPage;
